export default function SectionCard({  children, className }: { children: React.ReactNode, className?: string }) {
  return <section className={`SectionCard ${className ?? ""}`}>{children}</section>;
}
